export type AchievementCelebrationKind = "lesson" | "grammar" | "level" | "kanji" | "feature" | "achievement";

export type AchievementCelebration = {
    id: string;
    kind: AchievementCelebrationKind;
    title: string;
    message: string;
    xp?: number;
    level?: number;
    discoveryId?: string;
    shareable: boolean;
};

const SITE_URL = "https://nihongotech.teqseq.com";

export function lessonCelebration(id: string, title: string): AchievementCelebration {
    return { id: `lesson:${id}`, kind: "lesson", title, message: "You completed a Japanese lesson!", xp: 25, shareable: true };
}

export function grammarCelebration(id: string, title: string): AchievementCelebration {
    return { id: `grammar:${id}`, kind: "grammar", title, message: "You learned a new Japanese grammar rule!", xp: 15, shareable: true };
}

export function levelCelebration(level: number): AchievementCelebration {
    return { id: `level:${level}`, kind: "level", title: `Level ${level}`, message: `You reached Level ${level}!`, level, shareable: true };
}

export function featureDiscoveryCelebration(discovery: { id: string; title: string; message: string }): AchievementCelebration {
    return {
        id: `feature:${discovery.id}`,
        kind: "feature",
        title: discovery.title,
        message: discovery.message,
        discoveryId: discovery.id,
        shareable: true,
    };
}

export function achievementCelebration(achievement: { id: string; title: string; description: string }): AchievementCelebration {
    return { id: `achievement:${achievement.id}`, kind: "achievement", title: achievement.title, message: achievement.description, shareable: true };
}

export function achievementShareText(achievement: AchievementCelebration): string {
    if (achievement.kind === "achievement") return `I unlocked ${achievement.title} on NihongoTech!\n${SITE_URL}`;
    if (achievement.kind === "feature") return `I discovered ${achievement.title} on NihongoTech!\n${SITE_URL}`;
    if (achievement.kind === "lesson") return `I completed a Japanese lesson on NihongoTech! 🐢🇯🇵\n${SITE_URL}`;
    if (achievement.kind === "grammar") return `I learned a new Japanese grammar rule on NihongoTech! 🐢🇯🇵\n${SITE_URL}`;
    if (achievement.kind === "level") return `I reached Level ${achievement.level} on NihongoTech! 🐢🎉\n${SITE_URL}`;
    return `I reached a learning milestone on NihongoTech! 🐢🇯🇵\n${SITE_URL}`;
}

export function blueskyShareUrl(achievement: AchievementCelebration): string {
    return `https://bsky.app/intent/compose?text=${encodeURIComponent(achievementShareText(achievement))}`;
}

export function openBlueskyShare(achievement: AchievementCelebration): boolean {
    try {
        return window.open(blueskyShareUrl(achievement), "_blank", "noopener,noreferrer") !== null;
    } catch {
        return false;
    }
}
